import script from "./Portfolios.vue?vue&type=script&setup=true&lang=ts"
export * from "./Portfolios.vue?vue&type=script&setup=true&lang=ts"

import "./Portfolios.vue?vue&type=style&index=0&id=0dcd1dde&scoped=true&lang=scss"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dcd1dde"]])

export default __exports__